import { SchedulesAttributes, Ranges } from 'core_main/api/schedules/types';
import { Store } from 'core_main/types';
import { Availability } from './types';

export const createIsChatAvailableResponse = (status: Availability) => {
  return {
    availability: status,
  };
};

export const adjustDateWithTimezoneOffset = (
  timezoneOffset: SchedulesAttributes['timezoneOffset'],
): Date => {
  const newDate = new Date();
  const utc = newDate.getTime() + newDate.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(utc + timezoneOffset);
  return adjustedDate;
};

export const isInBusinessHours = (schedule: SchedulesAttributes): boolean => {
  const { hours, timezoneOffset } = schedule;

  const adjustedDate = adjustDateWithTimezoneOffset(timezoneOffset);

  const day = adjustedDate.getDay().toString() as keyof Ranges;

  const hoursOfDay = hours[day];

  if (!hoursOfDay || !Object.keys(hoursOfDay).length) return false;

  const adjustedDateHours = adjustedDate.getHours();
  const adjustedDateMinutes = adjustedDate.getMinutes();

  const adjustedDateTotalMinutes = adjustedDateHours * 60 + adjustedDateMinutes;

  const withinRange = hoursOfDay.find((range) => {
    const startOfRange = range[0];
    const endOfRange = range[1];

    return (
      adjustedDateTotalMinutes >= startOfRange &&
      adjustedDateTotalMinutes <= endOfRange
    );
  });

  return !!withinRange;
};

export const isInHoliday = (schedule: Store['schedule']): boolean => {
  const { timezoneOffset, holidays = [] } = schedule;

  const adjustedDate = adjustDateWithTimezoneOffset(timezoneOffset);

  const withinHoliday = holidays
    .filter((holiday) => holiday.attributes.enabled)
    .some((holiday) => {
      const start = new Date(holiday.attributes.startDate);
      const end = new Date(holiday.attributes.endDate);

      return adjustedDate >= start && adjustedDate <= end;
    });

  return withinHoliday;
};
